<template>
  <v-navigation-drawer
    v-model="show"
    floating
    app
  >
    <div class="mr-auto pt-5 pl-3 d-flex mb-3">
      <v-btn
        v-if="$vuetify.breakpoint.mobile"
        icon
        class="mr-3"
        @click="show = false"
      >
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-img
        :src="$images.FULL_LOGO"
        max-width="110"
        contain
      />
    </div>
    <v-list dense>
      <template v-for="(item, i) in filterItems(items)">
        <template v-if="filterItems(item.children).length">
          <v-list-group :key="i">
            <template #activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(child, j) in filterItems(item.children)"
              :key="j"
              value="true"
              :to="child.link"
              class="pl-8"
              exact
            >
              <v-list-item-content>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item
            :key="i"
            value="true"
            :to="item.href ? undefined : item.link"
            :href="item.href"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import enums from '../../helpers/enums';

export default {
  name: 'LeftNavigation',
  components: {},
  data: () => ({
    clipped: true,
    miniVariant: false,
    show: false
  }),
  computed: {
    items() {
      let items = [
        {
          title: 'Dashboard',
          link: '/',
          allowContentAdmin: true
        },
        {
          title: 'Template Designer',
          href: process.env.VUE_APP_TEMPLATE_DESIGNER_URL
        }
      ];

      items = items.concat(this.$enums.LINKS);

      return items;
    },
    ...mapGetters({ is_admin: 'auth/is_admin' })
  },

  mounted() {
    this.$bus.$on(enums.EVENT_BUS_EVENTS.SET_NAV_VISIBILITY, (val) => {
      if (val === 'toggle') this.show = !this.show;
      else this.show = val;
    });
    this.show = !this.$vuetify.breakpoint.mobile;
  },

  methods: {
    filterItems(items) {
      items = items || [];
      if (!this.is_admin) {
        items = items.filter((x) => x.allowContentAdmin);
      }
      return items;
    }
  }
};
</script>
